export var saveButton = 'Save';
export var cancelButton = 'Cancel';
